// About page events (analytics sheet → "About Page").
import {logAnalyticsEvent} from './analytics';
import {AnalyticsEntryPoint} from './events';
import type {TrackedSection} from './shared';

const ENTRY_POINT = AnalyticsEntryPoint.About;

export function trackAboutVideoUnmute(section: TrackedSection & {name: string}) {
  logAnalyticsEvent('video_unmute', {
    entry_point: ENTRY_POINT,
    section_name: section.name,
    section_id: section.id,
  });
}
